module.exports = __webpack_public_path__ + "img/soft-grove-vanity-2.39571f3d.jpeg";